// Screen 1: Classic Digital Watch
import React from 'react';

const ClassicWatch = ({ btcPrice, stats }) => {
  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Arial",
      backgroundColor: "#000000", // Black background
      color: "#00ff00", // Green text (classic terminal)
      padding: "2vw"
    }}>
      <div style={{ textAlign: "center" }}>
        {/* Screen Indicator */}
        <div style={{ 
          fontSize: "1.5vw", 
          color: "#666", 
          marginBottom: "1vh" 
        }}>
          CLASSIC WATCH
        </div>

        {/* Main Price */}
        <div style={{
          fontSize: "8vw",
          fontWeight: "bold",
          marginBottom: "2vh",
          color: "#00ff00",
          fontFamily: "Courier New, monospace"
        }}>
          {btcPrice === null ? "LOADING..." : `$${btcPrice.toLocaleString()}`}
        </div>

        {/* Key Stats in Terminal Style */}
        {stats && stats.timeframes && (
          <div style={{
            fontSize: "2.4vw",
            fontFamily: "Courier New, monospace",
            lineHeight: "1.6"
          }}>
            <div>1H: {stats.timeframes["1h"] && stats.timeframes["1h"].change >= 0 ? "+" : ""}{stats.timeframes["1h"] && stats.timeframes["1h"].change || "0.0"}%</div>
            <div>1D: {stats.timeframes["1d"] && stats.timeframes["1d"].change >= 0 ? "+" : ""}{stats.timeframes["1d"] && stats.timeframes["1d"].change || "0.0"}%</div>
            <div>1W: {stats.timeframes["1w"] && stats.timeframes["1w"].change >= 0 ? "+" : ""}{stats.timeframes["1w"] && stats.timeframes["1w"].change || "0.0"}%</div>
            <div style={{ marginTop: "2vh", color: "#666" }}>
              RANGE: ${stats.timeframes["1d"] && stats.timeframes["1d"].low && stats.timeframes["1d"].low.toLocaleString() || "0"} - ${stats.timeframes["1d"] && stats.timeframes["1d"].high && stats.timeframes["1d"].high.toLocaleString() || "0"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClassicWatch;



// WEBPACK FOOTER //
// ./src/screens/ClassicWatch.js